// src/scenes/warehouse/CreateWarehouse.jsx
import { useState } from "react";
import * as yup from "yup";
import axios from "axios";
import Header from "../../components/Header";
import SimpleForm from "../../components/SimpleForm";
import { Snackbar, Alert } from "@mui/material";

/* ---------- helpers ---------- */
const buildInitials = (fields) =>
  fields.reduce((acc, f) => {
    const def = f.default ?? (f.type === "checkbox" ? false : f.type === "number" ? 0 : "");
    acc[f.name] = def;
    return acc;
  }, {});

const buildSchema = (fields) => {
  const shape = {};
  fields.forEach((f) => {
    let rule;
    switch (f.type) {
      case "email": rule = yup.string().email("invalid email"); break;
      case "number": rule = yup.number().typeError("must be a number"); break;
      case "checkbox": rule = yup.boolean(); break;
      case "date": rule = yup.date().typeError("invalid date"); break;
      default: rule = yup.string();
    }
    if (f.required) rule = rule.required("required");
    if (f.min != null) rule = rule.min(f.min);
    if (f.max != null) rule = rule.max(f.max);
    if (f.matches) rule = rule.matches(f.matches.regex, f.matches.message);
    shape[f.name] = rule;
  });
  return yup.object().shape(shape);
};

/* ---------- API ---------- */
const token = localStorage.getItem("token");

const api = axios.create({
 baseURL: process.env.REACT_APP_API_URL,
  timeout: 15000,
  headers: { "Content-Type": "application/json",
    Authorization: `Bearer ${token}`, 
  },

});

async function postJSON(path, data) {
  try {
    const res = await api.post(path, data);
    return { data: res.data, error: null };
  } catch (err) {
    const serverErrors =
      err?.response?.data?.errors ||
      err?.response?.data?.message ||
      err.message;
    return { data: null, error: serverErrors };
  }
}

/* ---------- page config (fields must match your backend) ---------- */
const FIELDS = [
  { name: "name", label: "Category Name", type: "text", span: 2, required: true, props: { placeholder: "eg. Alcohol" }  },
   {
    name: "description",
    label: "Description",
    type: "text",
    span: 2,
    required: true,
    props: {
      placeholder: "eg. description of category",
   
    },
  },
];

const INITIALS = buildInitials(FIELDS);
const SCHEMA = buildSchema(FIELDS);

/* ---------- page ---------- */
export default function CreateCategory() {
  const [toast, setToast] = useState({ open: false, msg: "", sev: "success" });

 const handleSubmit = async (
  values,
  { setSubmitting, setErrors, resetForm }
) => {

  const payload = {
    name: values.name,
    description: values.description,
  };

  const { data, error } = await postJSON("/api/category", payload);

  setSubmitting(false);

  if (error) {
    if (typeof error === "object" && !Array.isArray(error)) {
      setErrors(error);
    }

    setToast({
      open: true,
      msg: "Failed to create category",
      sev: "error",
    });

    return;
  }

  const msg = data?.message || "Category created successfully";

  setToast({
    open: true,
    msg,
    sev: "success",
  });

  resetForm();
};

  return (
    <>
      <SimpleForm
        title="CREATE CATEGORY"
        subtitle="Add a new category"
        Header={Header}
        fields={FIELDS}
        initialValues={INITIALS}
        validation={SCHEMA}
        onSubmit={handleSubmit}
        submitLabel="Create category"
        columns={4}
      />

      <Snackbar
       anchorOrigin={{ vertical: 'top', horizontal: 'right'}}
      sx={{ mt: 5 }}
        open={toast.open}
        autoHideDuration={3000}
        onClose={() => setToast((s) => ({ ...s, open: false }))}
      >
        <Alert
          onClose={() => setToast((s) => ({ ...s, open: false }))}
          severity={toast.sev}
          variant="filled"
        >
          {toast.msg}
        </Alert>
      </Snackbar>
    </>
  );
}
